import { AppBar, Box, Button, Grid, Toolbar } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import defaultImage from '../../static/images/defaultImage.png';
import Counter from '../common/Counter';
import CurrencyDisplay from '../common/CurrencyDisplay';
import Header from '../common/Header';
import Progress from '../common/Progress';
import SetMenu from './SetMenu';
import Topping from './Topping';

@inject('commonStore', 'menuStore', 'cartStore')
@observer
class Menu extends Component {
  get menuAmount() {
    const { menuStore } = this.props;
    return menuStore.getMenuAmountInfo(menuStore.selectedMenu, menuStore.qty).totalAmount;
  }

  // 1회 주문 최대 구매 가능 수량 (장바구니에 담긴 동일 아이템 수량 차감, 0 - 제한없음)
  get maxQty() {
    const { menuStore, cartStore } = this.props;
    const limit = menuStore.selectedMenu.purchaseLimitCount;
    if (!limit || limit <= 0) return 0;

    const cartQty = cartStore.getCartItemTotalQty(menuStore.selectedMenu.itemCode);
    return Math.max(limit - cartQty, 1);
  }

  async componentDidMount() {
    const { commonStore, menuStore, match } = this.props;
    await commonStore.setData(match.params.companyId.toLowerCase(), match.params.storeCode);
    menuStore.setSelectedMenuByItemCode(match.params.itemCode, match.params.groupCode);
  }

  handleCountChange = count => {
    this.props.menuStore.setMenuQty(count);
  };

  handleMaxExceeded = () => {
    const { commonStore, menuStore, t } = this.props;
    commonStore.setSnackbar(
      true,
      t('cart.error.purchaseLimitPerOrder', {
        name: menuStore.selectedMenu.name,
        n: menuStore.selectedMenu.purchaseLimitCount,
      }),
    );
  };

  handleAddCartMenu = () => {
    const { cartStore, history } = this.props;

    const isSuccess = cartStore.addCartMenu();
    if (isSuccess) history.go(-1);
  };

  validURL = str => {
    var pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i',
    ); // fragment locator
    return !!pattern.test(str);
  };

  menuPriceComponent = () => {
    const { menuStore } = this.props;

    const menuPriceInfo = menuStore.getMenuPriceInfo(menuStore.selectedMenu);

    if (menuPriceInfo.discountAmount === 0) {
      return <CurrencyDisplay amount={menuPriceInfo.discountedAmount} size="large" />;
    } else {
      return (
        <div className="price-discount-info-vertical">
          <CurrencyDisplay amount={menuPriceInfo.price} type="disabled" size="large" />
          <span className="emphasis" style={{ fontSize: '18px' }}>
            {menuPriceInfo.discountPercentage}%
          </span>
          <CurrencyDisplay amount={menuPriceInfo.discountedAmount} type="emphasis" size="large" />
        </div>
      );
    }
  };

  render() {
    const { t, menuStore } = this.props;

    if (!menuStore.selectedMenu) {
      return <Progress />;
    }

    return (
      <React.Fragment>
        <Header page="CART" title={menuStore.selectedMenu.name} />

        <div className="contents">
          {/* 메뉴 기본 정보 */}
          <div className="menu-info">
            {/* 메뉴 사진 */}
            <div style={{ padding: '20px 0', textAlign: 'center' }}>
              <img
                src={menuStore.getImageUrl(
                  menuStore.selectedMenu.itemStoreCode,
                  menuStore.selectedMenu.pictureFileName1,
                  menuStore.selectedMenu.pictureFileName2,
                )}
                alt={menuStore.selectedMenu.name}
                height="140px"
                onError={e => (e.target.src = defaultImage)}
                style={{ maxWidth: '100%' }}
              />
            </div>
            {menuStore.selectedMenu.memo && (
              <p className="menu-memo">
                {menuStore.selectedMenu.memo.split('\n').map((text, index) => {
                  return (
                    <span key={index}>
                      {text}
                      <br />
                    </span>
                  );
                })}
              </p>
            )}
            {/* 수량 및 단가 */}
            <div style={{ paddingBottom: '15px' }}>
              <Grid container>
                <Grid item xs>
                  <Counter
                    max={this.maxQty}
                    onCountChange={this.handleCountChange}
                    onMaxExceeded={this.handleMaxExceeded}
                  />
                </Grid>
                <Grid
                  item
                  xs
                  style={{
                    textAlign: 'right',
                    lineHeight: '40px',
                  }}
                >
                  {this.menuPriceComponent()}
                </Grid>
              </Grid>
            </div>
          </div>

          {/* 토핑 */}
          {menuStore.selectedMenu.toppingGroups && menuStore.selectedMenu.toppingGroups.length > 0 && <Topping />}

          {/* 세트메뉴 */}
          {menuStore.selectedMenu.setMenuGroups && menuStore.selectedMenu.setMenuGroups.length > 0 && <SetMenu />}

          {/* 메뉴 설명 이미지 */}
          <div className="description-image-container">
            {this.validURL(menuStore.selectedMenu.descriptionImageUrl1) && (
              <div>
                <img
                  src={menuStore.selectedMenu.descriptionImageUrl1}
                  alt="메뉴 설명 이미지1"
                  onError={e => (e.target.style.display = 'none')}
                />
              </div>
            )}
            {this.validURL(menuStore.selectedMenu.descriptionImageUrl2) && (
              <div>
                <img
                  src={menuStore.selectedMenu.descriptionImageUrl2}
                  alt="메뉴 설명 이미지2"
                  onError={e => (e.target.style.display = 'none')}
                />
              </div>
            )}
            {this.validURL(menuStore.selectedMenu.descriptionImageUrl3) && (
              <div>
                <img
                  src={menuStore.selectedMenu.descriptionImageUrl3}
                  alt="메뉴 설명 이미지3"
                  onError={e => (e.target.style.display = 'none')}
                />
              </div>
            )}
            {this.validURL(menuStore.selectedMenu.descriptionImageUrl4) && (
              <div>
                <img
                  src={menuStore.selectedMenu.descriptionImageUrl4}
                  alt="메뉴 설명 이미지4"
                  onError={e => (e.target.style.display = 'none')}
                />
              </div>
            )}
          </div>
        </div>

        {/* 장바구니 버튼 */}
        <AppBar position="fixed" color="primary" className="bottom">
          <Toolbar variant="dense" style={{ padding: '0' }}>
            <Button fullWidth onClick={this.handleAddCartMenu} className="bottom-button">
              <Box className="bottom-button-title">{t('cart.button.addCount', { n: menuStore.qty })}</Box>
              <Box bgcolor="secondary.main" className="bottom-button-amount">
                <CurrencyDisplay amount={this.menuAmount} size="large" />
              </Box>
            </Button>
          </Toolbar>
        </AppBar>
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(Menu));
